// extracted by mini-css-extract-plugin
export default {"relatenews":"index_relatenews_Pz4-X","relateHeader":"index_relateHeader_yE-lK","relateTitle":"index_relateTitle_gLqTX"};